import type { Options } from './locale';

export const validateOptions = (options: Options): Options => {
  return options;
};
